export default __webpack_public_path__ + "static/media/V210MAND2.bb7ea8ca.pdf";